/**
 * Created by 唐亦慧 on 2017/8/29.
 */

import {config, request, objectSerial} from 'Utils';


//获取员工列表
export function peopleList(param) {
    return request(`${config.server}/api/v1/dms/employee/emplist`, {
        method: 'post',
        body: param
    });
}

export function orgAsyc() {
    return request(`${config.server}/api/v1/dms/oaMessage/emp`);
}

//新增员工

/*
*{
 "account": "hcs_test1",
 "contactInfoList": [
 {
 "type": 3,
 "content": "huangcs@coracle.com"
 },
 {
 "type": 1,
 "content": "13689597476"
 }
 ],
 "employeeOrganizationList": [
 {
 "organizationId": 10,
 "postId": 1,
 "isCharge": 1,
 "isMajor": 1
 },
 {
 "organizationId": 7,
 "postId": 6,
 "isCharge": 1,//主负责人
 "isMajor": 0//主组织
 }
 ],
 "name": "黄朝圣",
 "sex": 1,
 "plainPassword": "123456",
 "status": 1
 }
 * */
export function peopleAdd(param) {
    return request(`${config.server}/api/v1/dms/employee/insert`, {
        method: 'post',
        body: param
    });
}


//编辑员工
export function peopleUpdate(param) {
    return request(`${config.server}/api/v1/dms/employee/update`, {
        method: 'post',
        body: param
    });
}


//删除员工
//{ids:[1,2,3,4]}
export function peopleDelete(param) {
    return request(`${config.server}/api/v1/dms/employee/delete`, {
        method: 'post',
        body: param
    });
}

//获取员工详情
export function peopleDetail(param) {
    return request(`${config.server}/api/v1/dms/employee/detail?${objectSerial(param)}`);
}


/**
 * 自定义快捷方式 插件的左边数据
 * @param param
 * @returns {*}
 */
export function channelLeftSideList() {
    return request(`${config.server}/api/v1/dms/homePage/channel`, {
        method: 'get'
    });
}

export function businessLeftSideList() {
    return request(`${config.server}/api/v1/dms/homePage/business`, {
        method: 'get'
    });
}

/**
 * 渠道弹出框 客户当前的列表
 * @param param
 * @returns {*}
 */
export function fetchCustomChannelList(param) {
    return request(`${config.server}/api/v1/dms/dmsTgChannel/searchByCus${objectSerial(param)}`, {
        method: 'get'
    });
}

/**
 * 自定义快捷方式 保存自定义快捷方式接口
 * @param param
 * @returns {*}
 */
export function saveModules(param) {
    return request(`${config.server}/api/v1/dms/dmsTgChannel/saveChannel`, {
        method: 'post',
        body: param
    });
}

export function saveModules2(param) {
    return request(`${config.server}/api/v1/dms/dmsTgChannel/saveBusiness`, {
        method: 'post',
        body: param
    });
}


// WEBPACK FOOTER //
// ./src/service/people/index.js